/**
 * Explore page header.
 */
import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import { VText } from "form";

/**
 * Title and intro copy for the course catalog.
 */
const ExploreHeader = () => {
  const { t } = useTranslation("common");

  return (
    <Box className="w-full md:p-0 p-2 v-bg-body">
      <Box className="md:rounded-none rounded-md relative flex">
        <Box className="hidden md:block w-full aspect-[4/1] rounded-md bg-cover bg-center bg-red-300" sx={{ backgroundImage: `url(${process.env.REACT_APP_S3_ASSET_ENDPOINT}/v2-assets/app/explore-banner.svg)` }} />
        <Box className="md:hidden w-full aspect-[5/4] max-h-96 rounded-md bg-cover bg-center bg-red-300" sx={{ backgroundImage: `url(${process.env.REACT_APP_S3_ASSET_ENDPOINT}/v2-assets/app/explore-banner.svg)` }} />
        <Box className="h-full w-full mx-auto absolute top-0 left-0">
          <Box className="flex items-center h-full mx-auto w-4/5">
            <Box className="flex flex-col gap-0 md:gap-4">
              <VText className="text-4xl md:text-5xl" color="white">
                {t("Knowledge awakens your abilities, experience enriches your skills")}
              </VText>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ExploreHeader;
